import { createFileRoute, notFound } from '@tanstack/react-router';

import { ApiError, ApiErrorType } from '@/lib/api/error';
import { queryClient } from '@/lib/queryClient';

import { getInstallableSoftwareDetail } from '../../-query/api';
import { softwareLibraryKey } from '../../-query/key';

export const Route = createFileRoute(
  '/_staff/software/_layout/library/detail/$softwareLibraryId/',
)({
  loader: async ({ params }) => {
    try {
      await queryClient.ensureQueryData({
        queryKey: softwareLibraryKey.detail(params.softwareLibraryId),
        queryFn: () => getInstallableSoftwareDetail(params.softwareLibraryId),
      });
    } catch (error) {
      if (error instanceof ApiError && error.is(ApiErrorType.NotFound)) {
        throw notFound();
      }
      throw error;
    }
  },
});
